export default __webpack_public_path__ + "static/media/videoplayback.2b9f13c6.webm";